

const ServicesSection = () => {


  const services = [
    {
      icon: 'ri-heart-line',
      title: 'Tatuajes Delicados',
      description: 'Diseños minimalistas y elegantes perfectos para tu primera experiencia',
      whatsappMessage: 'Hola! Me interesa información sobre tatuajes delicados 🌸'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Tatuajes Botánicos',
      description: 'Flores, plantas y elementos naturales con un toque artístico único',
      whatsappMessage: 'Hola! Quiero saber más sobre tatuajes botánicos 🌿'
    },
    {
      icon: 'ri-text',
      title: 'Lettering',
      description: 'Frases y palabras con tipografías personalizadas y significativas',
      whatsappMessage: 'Hola! Me interesa un tatuaje de lettering ✍️'
    },
    {
      icon: 'ri-palette-line',
      title: 'Tatuajes a Color',
      description: 'Diseños vibrantes con técnicas de acuarela y colores intensos',
      whatsappMessage: 'Hola! Quiero información sobre tatuajes a color 🎨'
    },
    {
      icon: 'ri-star-line',
      title: 'Cover Up',
      description: 'Transformamos tatuajes antiguos en nuevas obras de arte',
      whatsappMessage: 'Hola! Necesito información sobre cover up de tatuajes 🔄'
    },
    {
      icon: 'ri-brush-line',
      title: 'Tatuajes Realistas',
      description: 'Retratos y diseños hiperrealistas con técnica profesional',
      whatsappMessage: 'Hola! Me interesa un tatuaje realista 📸'
    },

  ];



  const handleWhatsAppClick = (message: string, phone: string) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phone}?text=${encodedMessage}`, '_blank');
  };

  return (
    <section id="servicios" className="py-20 bg-gradient-to-br from-pink-50 via-white to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nuestros <span className="text-pink-500">Servicios</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Desde <strong>tatuajes artísticos</strong> hasta <strong>tratamientos especializados</strong>,
            ofrecemos una experiencia completa de arte corporal y bienestar
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"

              onClick={() => handleWhatsAppClick(service.whatsappMessage, '56982504829')}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-pink-500/10 to-purple-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              <div className="relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-pink-600 transition-colors">
                  {service.title}
                </h3>

                <p className="text-gray-600 leading-relaxed mb-6">
                  {service.description}
                </p>

                <div className="flex items-center text-pink-500 font-semibold group-hover:text-pink-600 transition-colors">
                  <span className="mr-2">Reservar</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
};

export default ServicesSection;
